export class User {
  staff_id: number;
  role: string;
  full_name: string;
  phone_number: string;
  is_active: number;
  login_pin: string;
  is_delete: number;
  access_token: string;

  constructor(value: any = {}) {
    Object.assign(this, value);
  }
}
